import lazyLoading from "./lazyLoading";

export default {
  name: "narucioci",
  path: "/narucioci",
  component: lazyLoading("narucioci/narucioci"),
  meta: {
    default: false,
    title: "Group email",
    class: "info",
    show: false,
    iconClass: "glyphicon glyphicon-envelope",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/narucioci.js